
import GallerySlider from './GallerySlider';

import './scss/_omoss.css';

export default function OmOss() {

    const certs = [
        { img: "./cert1.jpg", alt: "" },
        { img: "./cert2.jpg", alt: "" },
        { img: "./cert3.jpg", alt: "" },
        { img: "./cert4.jpg", alt: "" },
        { img: "./cert5.jpg", alt: "" },
        { img: "./cert6.png", alt: "" },
    ];

    return (
        <section id="omoss">
            <div className="cs-container">
                <h2 >Jeg heter Iuliia Moiseienko og er autorisert fotterapeut.</h2>
                <div className="flex">
                    <div>
                        <img src="./autorisert-fotterapy.webp" className="w-48 h-48 object-cover rounded-lg shadow" />
                    </div>
                    <div className="max-w-xl text-left">
                            <p className="text-left size-12">Min faglige bakgrunn startet for over 20 år siden i Ukraina, hvor jeg utdannet meg og jobbet som sykepleier. Etter mer enn 10 år i Norge har jeg erfaring som helsefagarbeider og har videre spesialisert meg innen fothelse som autorisert fotterapeut.</p>

                            <p className="text-left  size-12">Denne kombinasjonen av bred medisinsk erfaring og spesialisert kompetanse gjør at jeg kan tilby trygg, faglig forsvarlig og individuelt tilpasset behandling. Jeg har stort fokus på kvalitet, sikkerhet og god oppfølging, med mål om å gi deg sunne og komfortable føtter.</p>

                            <p className="text-left  size-12"> Ta gjerne kontakt for timeavtale eller mer informasjon.</p>



                    </div>
                </div>
                <div className="block">
                    <p className="section-subtitle">Mine sertifikater</p>
                    <GallerySlider images={certs} autoDelayMs={10000} />
                </div>
            </div>
        </section>
    );
}